export enum ProductSliderEvent {
    PRODUCT_SLIDER_DATA_UPDATED = 'productSlider:data:updated',
}
